import React, { useState, useEffect } from 'react';
import './App.css';
import IntroAnimation from './components/IntroAnimation';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import ProductShowcase from './components/ProductShowcase';
import WhyDanstonAI from './components/WhyDanstonAI';
import WhatWeDo from './components/WhatWeDo';
import Solutions from './components/Solutions';
import UseCases from './components/UseCases';
import WhyChoose from './components/WhyChoose';
import BusinessImpact from './components/BusinessImpact';
import CallToAction from './components/CallToAction';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ComingSoon from './components/ComingSoon';

function App() {
  const [showIntro, setShowIntro] = useState(true);
  const [showWebsite, setShowWebsite] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);

  useEffect(() => {
    // Check if user has seen the intro in this session
    const hasSeenIntro = sessionStorage.getItem('hasSeenIntro');
    if (hasSeenIntro === 'true') {
      setShowIntro(false);
      setShowWebsite(true);
    }

    // Check if we're on the coming soon route
    if (window.location.pathname === '/coming-soon') {
      setShowIntro(false);
      setShowWebsite(false);
      setShowComingSoon(true);
    }
  }, []);

  const handleIntroComplete = () => {
    sessionStorage.setItem('hasSeenIntro', 'true');
    setShowIntro(false);
    setTimeout(() => {
      setShowWebsite(true);
    }, 300);
  };

  if (showComingSoon) {
    return <ComingSoon />;
  }

  return (
    <div className="App">
      {showIntro && <IntroAnimation onComplete={handleIntroComplete} />}
      
      {showWebsite && (
        <div className="website-content">
          <Navigation />
          <Hero />
          <ProductShowcase />
          <WhyDanstonAI />
          <WhatWeDo />
          <Solutions />
          <UseCases />
          <WhyChoose />
          <BusinessImpact />
          <CallToAction />
          <About />
          <Contact />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default App;
